<template>
  <div
    v-if="question"
    class="bg-white mt-[30px]"
  >
    <h3 class="bg-yellow text-2xl text-center text-white py-[10px]">
      Teszteld magad!
    </h3>
    <p class="mt-[30px] mx-[20px] mb-[20px] font-source-serif-pro font-semibold text-center">
      {{ question.question }}
    </p>
    <div
      v-for="media in question.media"
      :key="media.file.id"
      class="mx-[30px] text-center mb-3"
    >
      <picture
        v-if="media.file.mime_type.includes('image')"
        class="block"
      >
        <img
          :src="media.file.url"
          class="mx-auto"
        >
      </picture>
      <audio
        v-if="media.file.mime_type.includes('audio') || media.file.mime_type.includes('octet')"
        controls
        class="w-full"
        preload="none"
      >
        <source
          :src="encodeURI(media.file.url)"
          :type="media.file.mime_type"
        >
        A böngésződ nem támogatja a beágyazott audio tartalmakat!
      </audio>
      <video
        v-if="media.file.mime_type.includes('video')"
        controls
        class="img-responsive w-100"
        preload="none"
      >
        <source
          :src="encodeURI(media.file.url)"
          :type="media.file.mime_type"
        >
        A böngésződ nem támogatja a beágyazott video tartalmakat!
      </video>     
      <a
        v-if="media.urlMedia && media.file.original"
        :href="media.file.original"
        class="link link-yellow"
        target="_blank"
      >forrás</a>
    </div>
    
    <div
      v-for="(answer, index) in question.answers"
      :key="question.id + '-' + answer.id"
      class="mx-[30px]"
    >
      <ReCheckbox
        v-model="answers[index]"
        :class="{ 
          'bg-green': showAnswer && answer.right
        }"
        :disabled="showAnswer"
        type="left"
      >
        <span v-html="answer.answer" />
      </ReCheckbox>
    </div>
    <div
      v-if="showAnswer"
      class="text-center mx-[30px] mt-[20px]"
    >
      <p
        class="font-semibold"
      >
        {{
          goodAnswer === true
            ? "Helyes válasz, gratulálunk!"
            : "Helytelen válasz"
        }}
      </p>
    </div>
    <div class="text-center">
      <button
        v-show="!showAnswer"
        id="show"
        class="my-[30px] mx-auto btn btn-red"
        type="button"
        @click="revealResult"
      >
        <span>Lássuk a helyes választ!</span>
      </button>
      <button
        v-show="showAnswer"
        id="new"
        class="my-[30px] mx-auto btn btn-red"
        type="button"
        @click="goToKnowledgebase"
      >
        <span>Új kérdés</span>
      </button>
    </div>
    <div class="text-center">
      <nuxt-link
        :to="'/folkszemle/tudasproba?game=' + this.$unique()"
        title="Idézetgyűjtemény"
        class="link link-yellow"
      >
        Tudáspróba
      </nuxt-link>
    </div>
    <img
       
      src="/img/kviz_rajz.svg"
      class="mx-auto mt-[50px] pb-[15px] h-[40px]"
      alt=""
    > 
  </div>
</template>
<script>
import ReCheckbox from "~/components/rxt/reform/ReCheckbox.vue";
export default {
  components: {
    ReCheckbox
  },
  data () {
    return {
      showAnswer: false,
      question: null,
      answers: [],
      goodAnswer: false
    }
  },
  fetch(){
    this.$axios.get("knowledge/questions?limit=1&sort=random").then(response => {
      this.question = response.data.data[0];
    })
  },
  methods: {    
    revealResult() {
      this.showAnswer = true;
      this.answered++;

      // calculate result for previous question
      let bad = false;
      this.question.answers.forEach((a, aindex) => {
        if (
          this.answers[aindex] === true &&
          this.question.answers[aindex].right === false
        ) {
          bad = true;
        } else if (
          this.answers[aindex] === false &&
          this.question.answers[aindex].right === true
        ) {
          bad = true;
        }
      });
      if (!bad) {
        this.goodAnswer = true;
      } else {
        this.goodAnswer = false;
      }
    },
    goToKnowledgebase() {
      this.$store.commit('setQuestion', { question: this.question, right: this.goodAnswer})

      this.$router.push('/folkszemle/tudasproba?game=' + this.$unique())
    }
  }
}
</script>
